import React from 'react';
import { Divider, Paper, Stack, Typography } from '@mui/material';
import { EditableFieldRow } from './EditableFieldRow';
import { FieldEditState } from '../types';

interface FieldGroupSectionProps {
  groupLabel: string;
  fields: FieldEditState[];
  onChange: (key: string, value: string) => void;
  onRevert: (key: string) => void;
}

export const FieldGroupSection = ({ groupLabel, fields, onChange, onRevert }: FieldGroupSectionProps) => {
  if (fields.length === 0) return null;

  return (
    <Paper variant="outlined" sx={{ p: 2 }}>
      <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
        {groupLabel}
      </Typography>
      <Stack divider={<Divider />}>
        {fields.map(field => (
          <EditableFieldRow key={field.key} field={field} onChange={onChange} onRevert={onRevert} />
        ))}
      </Stack>
    </Paper>
  );
};
